var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M40,4c19.9,0,36,16.1,36,36c0,19.9-16.1,36-36,36C20.1,76,4,59.9,4,40C4,20.1,20.1,4,40,4z M55.1,24.6 c-3.8-3.8-8.8-5.9-14.1-5.9c-11,0-20,9-20,20c0,3.5,0.9,7,2.7,10L20.8,59l10.6-2.8c2.9,1.6,6.2,2.4,9.5,2.4c11,0,20-9,20-20 C61,33.4,58.9,28.3,55.1,24.6z M41,55.3c-3,0-5.9-0.8-8.5-2.3l-0.6-0.4l-6.3,1.6l1.7-6.1l-0.4-0.6c-1.7-2.6-2.5-5.7-2.5-8.8 c0-9.2,7.5-16.6,16.6-16.6c4.4,0,8.6,1.7,11.7,4.9c3.1,3.2,4.9,7.3,4.9,11.7C57.6,47.8,50.2,55.3,41,55.3L41,55.3z M50.1,42.9 c-0.5-0.3-3-1.4-3.4-1.6c-0.5-0.2-0.8-0.3-1.1,0.3c-0.3,0.5-1.3,1.6-1.6,2c-0.3,0.3-0.6,0.4-1.1,0.1s-2.1-0.8-4-2.5 c-1.5-1.3-2.5-3-2.8-3.5c-0.3-0.5,0-0.8,0.2-1c0.2-0.2,0.5-0.6,0.8-0.9c0.3-0.3,0.3-0.5,0.5-0.8c0.2-0.3,0.1-0.6,0-0.9 s-1.1-2.7-1.5-3.7c-0.4-1-0.8-0.8-1.1-0.9c-0.3,0-0.6,0-1,0s-0.9,0.1-1.3,0.6c-0.5,0.5-1.7,1.7-1.7,4.2c0,2.5,1.8,4.8,2,5.2 c0.3,0.3,3.5,5.4,8.5,7.5c1.2,0.5,2.1,0.8,2.9,1.1c1.2,0.4,2.3,0.3,3.2,0.2c1-0.2,3-1.2,3.4-2.4s0.4-2.2,0.3-2.4 C51,43.2,50.6,43.1,50.1,42.9L50.1,42.9z"
});

function SvgIconWa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWa);
export default __webpack_public_path__ + "static/media/icon_wa.8ee65f58.svg";
export { ForwardRef as ReactComponent };